import { AxiosClient } from './httpClient';

export default class DonorManagerAPI {
  static getDonations(token: string) {
    return AxiosClient.get(`/authen/donors/donations`, {}, { Authorization: `${token}` });
  }

  static getDonationDetail(donation_id: string, token: string) {
    return AxiosClient.get(`/authen/donors/donation-detail/${donation_id}`, {}, { Authorization: `${token}` });
  }

  static getLands() {
    return AxiosClient.get(`/lands`);
  }

  static checkDonor(params: any) {
    return AxiosClient.post(`/authen/donors/link`, params);
  }

  static getCertificate(id: string, lang: string, token: string) {
    return AxiosClient.get(`/authen/donors/donation/${id}/certificate?lang=${lang}`, {}, { Authorization: `${token}` });
  }

  static getRecurringCertificateByYear(id: string, lang: string, year: any, token: string) {
    return AxiosClient.get(`/authen/donors/donation/${id}/recurring-certificate/${year}?lang=${lang}`, {}, { Authorization: `${token}` });
  }

  static getReceipt(id: string, data: any, lang: string, token: string) {
    return AxiosClient.put(`/authen/donors/donation/${id}/receipt?lang=${lang}`, data, { Authorization: `${token}` });
  }

  static getRecurringReceiptByYear(id: string, year: any, data: any, lang: string, token: string) {
    return AxiosClient.put(`/authen/donors/donation/${id}/recurring-receipt/${year}?lang=${lang}`, data, { Authorization: `${token}` });
  }

  static getStripeLink(currency: string, token: string) {
    return AxiosClient.get(`/authen/donors/stripe-link/${currency}`, {}, { Authorization: `${token}` });
  }

  static getDonorDonation(id: string, token: string) {
    return AxiosClient.get(`/authen/donors/donation/${id}`, {}, { Authorization: `${token}` });
  }

  static updateDonorDonation(id: string, data: any, token: string) {
    return AxiosClient.put(`/authen/donors/donation/${id}`, data, { Authorization: `${token}` });
  }
}
